define(function(require) {
	const standardCardDefaults = require('../standard/defaults');
	var descriptionCard = JSON.parse(JSON.stringify(standardCardDefaults.card));
	descriptionCard.menu = [
		{
			optionName:"Default Option Name",
			optionValue:"DefaultOptionValue"
		}
	];
	//link and value are mutually exclusive. link will always be used when present
	descriptionCard.headerButton = {
		text:"Default Button Text",
		value:"DefaultButtonValue",
		link:'',
		priority:'primary'
	};
	descriptionCard.isDescription = true;
	descriptionCard.card = {};

	delete descriptionCard.data;
	
	return {
		card:descriptionCard,
		//no differences between fields, return standard fields.
		field:standardCardDefaults.field
	};
});